import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { getCapabilityColor } from '../../utils/colorUtils';

interface PersonaCapabilityMeterProps {
  label: string;
  value: number;
  max: number;
}

export const PersonaCapabilityMeter: React.FC<PersonaCapabilityMeterProps> = ({
  label,
  value,
  max
}) => {
  const { darkMode } = useTheme();
  
  // Calculate percentage for width
  const percentage = (value / max) * 100;
  
  // Get the capability name from the label (lowercase for matching)
  const capabilityName = label.toLowerCase();

  return (
    <div className="capability-meter">
      <div className="flex justify-between items-center mb-1">
        <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>{label}</span>
        <span className={`text-sm font-medium ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>{value}/{max}</span>
      </div>
      <div className={`w-full ${darkMode ? 'bg-gray-700' : 'bg-gray-200'} rounded-full h-2`}>
        <div 
          className={`${getCapabilityColor(capabilityName)} h-2 rounded-full`} 
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
};
